export const BROWSER_FOCUS_CHANGE = 'BROWSER_FOCUS_CHANGE'
export const REALTIME_SERVICE_CONNECTION_CHANGE = 'REALTIME_SERVICE_CONNECTION_CHANGE'
